<div class="sort-filter">
  <button
    class="w-9 h-9 rounded-[6px] bg-neutrals-0"
    [matMenuTriggerFor]="sortFilterMenuOptionList"
  >
    <ui-icon name="swap" fill="neutrals-600" m-size="16" size="16" />
  </button>

  <mat-menu #sortFilterMenuOptionList="matMenu" class="bg-white">
    <div
      class="grid grid-flow-row p-4 w-[256px]"
      (click)="$event.stopImmediatePropagation()"
    >
      <ui-paragraph
        class="px-2"
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        {{ title }}
      </ui-paragraph>
      <mat-radio-group
        class="mt-3"
        [(ngModel)]="sortStyle"
        color="primary"
        (change)="sort.emit($event)"
      >
        <mat-radio-button *ngFor="let sortType of items" [value]="sortType">
          <ui-paragraph
            type="p12"
            mobile-type="p12"
            [attr.text-color]="
              sortType === sortStyle ? 'neutrals-900' : 'neutrals-700'
            "
            font-weight="regular"
          >
            {{ description[sortType] }}
          </ui-paragraph>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </mat-menu>
</div>
